import { render, staticRenderFns } from "./onboarding.vue?vue&type=template&id=46bc18f6&"
import script from "./onboarding.vue?vue&type=script&lang=js&"
export * from "./onboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports